/**
 * `/tenants` index — Link Admin tenant list (LADM-01).
 *
 * Owns the validated search params + mounts <TenantsListScreen>. Lives
 * here (not in the parent layout file) so sibling routes /tenants/new and
 * /tenants/{id}/brand can render without satisfying the list's filter
 * schema. See routes/_auth.tenants.tsx header for the split rationale.
 *
 * URL search params are Zod-validated so direct deep-links work and
 * back/forward navigation preserves filter state.
 */
import { z } from "zod";
import { createFileRoute } from "@tanstack/react-router";
import { TenantsListScreen } from "../features/tenants/TenantsListScreen";

const tenantsSearchSchema = z.object({
  status: z.enum(["ACTIVE", "SUSPENDED"]).optional(),
  planCode: z.string().optional(),
  createdFrom: z.string().optional(),
  createdTo: z.string().optional(),
  limit: z.coerce.number().int().positive().max(100).default(20),
  offset: z.coerce.number().int().nonnegative().default(0),
});

export const Route = createFileRoute("/_auth/tenants/")({
  validateSearch: tenantsSearchSchema,
  component: TenantsListScreen,
});
